import React, { FunctionComponent } from 'react';

import classes from './styles/api-keys-table.module.scss';

interface ApiKeysTableProps {
  organizationKey: string;
  organizationSlug: string;
}

/**
 * Placeholder component for the API Keys table.
 * The table implementation (columns, rows, sorting, pagination)
 * and modal dialogs (Create, Revoke, Rotate) will be built
 * in subsequent tickets.
 */
export const ApiKeysTable: FunctionComponent<ApiKeysTableProps> = ({
  // organizationKey,
  // organizationSlug,
}) => {
  return (
    <div className={classes.apiKeysTablePlaceholder}>
      {/* Table component will be implemented here */}
    </div>
  );
};
